// extracted by mini-css-extract-plugin
module.exports = {"container":"NotifyMeButton_container__3jjL0","wrapperButton":"NotifyMeButton_wrapperButton__1DJL1","copy":"NotifyMeButton_copy__11eZz"};